import './Common.css';



function NavElement() {
    return (
        <div className='NavElement'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 NavBar'>
                        <ul>
                            <li><a href='#home'>Home</a></li>
                            <li><a href='#faq-manual'>FAQ'S AND MANUAL</a></li>
                            <li><a href='#pricing'>PRICING</a></li>
                            <li><a href='#newsandevents'>News & Events</a></li>
                            <li><a href='#download'>DOWNLOADS</a></li>
                            <li><a href='#contactus'>CONTACT US</a></li>
                        </ul>
                    </div>
                    {/* <div className='col-md-5 RnavBar'>
                        <ul>
                            <li><a href='#'>Apply <i class="fas fa-chevron-right"></i></a></li>
                            <li><a href='#'>renew <i class="fas fa-chevron-right"></i></a></li>
                            <li><a href='#'>transfer <i class="fas fa-chevron-right"></i></a></li>
                            <li><a href='#'>Track Your Status <i class="fas fa-chevron-right"></i></a></li>
                        </ul>
                    </div> */}
                </div>
            </div>
        </div>
    );
  }
  
  export default NavElement;